import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchDashboard = createAsyncThunk('dashboard/fetch', async () => {
  const { data } = await api.get('/dashboard/');
  return data;
});

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: { kpis: {}, echeances: [], evolution: [], domaines: [], notifs: [], loading: false },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchDashboard.pending,   (s) => { s.loading = true; })
     .addCase(fetchDashboard.fulfilled, (s, { payload }) => {
       s.loading = false;
       s.kpis     = payload.kpis || {};
       s.echeances = payload.prochaines_echeances || [];
       s.evolution = payload.evolution_mensuelle || [];
       s.domaines  = payload.repartition_domaines || [];
       s.notifs    = payload.notifications_recentes || [];
     })
     .addCase(fetchDashboard.rejected, (s) => { s.loading = false; });
  },
});
export default dashboardSlice.reducer;
